// import {
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   TextField,
//   Grid,
//   Box,
// } from "@mui/material";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
// import dayjs from "dayjs";
// import { useState, useEffect } from "react";

// const EditScheduleDialog = ({
//   open,
//   handleClose,
//   schedule,
//   onConfirm,
//   loading,
// }) => {
//   const [groupName, setGroupName] = useState("");
//   const [selectedTime, setSelectedTime] = useState(null);

//   // Reset form when schedule changes or dialog opens
//   useEffect(() => {
//     if (schedule) {
//       setGroupName(schedule.group_name || "");
      
//       // Parse time from schedule if available
//       if (schedule.time) {
//         // Try to parse the time string to dayjs object
//         const timeFormats = ["hh:mm A", "HH:mm", "h:mm A", "H:mm"];
//         let parsedTime = null;
        
//         for (const format of timeFormats) {
//           const attempt = dayjs(schedule.time, format);
//           if (attempt.isValid()) {
//             parsedTime = attempt;
//             break;
//           }
//         }
        
//         setSelectedTime(parsedTime || dayjs());
//       }
//     }
//   }, [schedule]);

//   const handleSubmit = () => {
//     if (!groupName.trim() || !selectedTime) return;
    
//     const timeIn24HourFormat = dayjs(selectedTime).format("HH:mm");
    
//     onConfirm({
//       group_name: groupName.trim(),
//       time: timeIn24HourFormat,
//     });
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       aria-labelledby="edit-dialog-title"
//       maxWidth="sm"
//       fullWidth
//     >
//       <DialogTitle id="edit-dialog-title">Edit Schedule</DialogTitle>
//       <DialogContent>
//         <DialogContentText sx={{ mb: 3 }}>
//           Edit the delivery truck schedule for group{" "}
//           <strong>{schedule?.group_name}</strong>.
//         </DialogContentText>

//         <Grid container spacing={3}>
//           <Grid item xs={12}>
//             <TextField
//               label="Group Name"
//               value={groupName}
//               onChange={(e) => setGroupName(e.target.value)}
//               fullWidth
//               size="small"
//               required
//               placeholder="Enter group name"
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <LocalizationProvider dateAdapter={AdapterDayjs}>
//               <TimePicker
//                 label="Select Time"
//                 value={selectedTime}
//                 onChange={(newValue) => setSelectedTime(newValue)}
//                 viewRenderers={{
//                   hours: renderMultiSectionDigitalClockTimeView,
//                   minutes: renderMultiSectionDigitalClockTimeView,
//                 }}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     size: "small",
//                     required: true,
//                   },
//                   layout: {
//                     sx: {
//                       '& .MuiDigitalClock-root': {
//                         width: '100%',
//                         maxHeight: '300px',
//                       },
//                     },
//                   },
//                 }}
//                 ampm={true}
//               />
//             </LocalizationProvider>
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions sx={{ mb: 2, mr: 2, mt: 2 }}>
//         <Button
//           variant="outlined"
//           onClick={handleClose}
//           color="primary"
//           disabled={loading}
//         >
//           Cancel
//         </Button>
//         <Button
//           variant="contained"
//           onClick={handleSubmit}
//           color="primary"
//           disabled={loading || !groupName.trim() || !selectedTime}
//           sx={{
//             backgroundColor: "#4CAF50",
//             "&:hover": { backgroundColor: "#388E3C" },
//           }}
//         >
//           {loading && (
//             <CircularProgress size={24} sx={{ mr: 1 }} color="inherit" />
//           )}
//           {loading ? "Updating..." : "Update"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EditScheduleDialog;

// ********************************************************************

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Grid,
  Box,
  Chip,
  Typography,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { renderMultiSectionDigitalClockTimeView } from "@mui/x-date-pickers/timeViewRenderers";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import httpclient from "../../../Utils";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const EditScheduleDialog = ({
  open,
  handleClose,
  schedule,
  onConfirm,
  loading,
}) => {
  const [groupName, setGroupName] = useState("");
  const [selectedTime, setSelectedTime] = useState(null);
  const [bayOptions, setBayOptions] = useState([]);
  const [selectedBays, setSelectedBays] = useState([]);
  const [loadingBays, setLoadingBays] = useState(false);
  const [error, setError] = useState("");

  const handleApiError = useApiErrorHandler();

  // Fetch bays when dialog opens
  useEffect(() => {
    if (open) {
      fetchBays();
    }
  }, [open]);

  // Load schedule data when schedule changes
  useEffect(() => {
    if (schedule && open) {
      console.log("Loading schedule:", schedule);
      setGroupName(schedule.group_name || "");
      
      // Parse time from schedule
      if (schedule.time) {
        const timeFormats = ["hh:mm A", "HH:mm", "h:mm A", "H:mm"];
        let parsed = null;

        for (const f of timeFormats) {
          const attempt = dayjs(schedule.time, f);
          if (attempt.isValid()) {
            parsed = attempt;
            break;
          }
        }

        setSelectedTime(parsed || dayjs());
      }

      // Load selected bays from schedule.selected_bays
      if (schedule.selected_bays && Array.isArray(schedule.selected_bays)) {
        // Extract just the bay values from the bay objects
        const bayValues = schedule.selected_bays.map(bay => bay.bay);
        setSelectedBays(bayValues);
        console.log("Loaded bay values:", bayValues);
      } else {
        setSelectedBays([]);
      }
    }
  }, [schedule, open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      setGroupName("");
      setSelectedTime(null);
      setSelectedBays([]);
      setError("");
    }
  }, [open]);

  const fetchBays = async () => {
    setLoadingBays(true);
    try {
      const response = await httpclient.get("/delivery-truck-schedule");
      
      if (response.data.status === 200) {
        const bayList = response.data.bay_list || [];
        setBayOptions(bayList);
        console.log("Bay options loaded for edit:", bayList);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoadingBays(false);
    }
  };

  const handleBayChange = (event) => {
    const {
      target: { value },
    } = event;
    
    const selectedValues = typeof value === 'string' ? value.split(',') : value;
    setSelectedBays(selectedValues);
    setError("");
  };

  const handleDeleteBay = (bayValueToDelete) => {
    setSelectedBays(selectedBays.filter(bayValue => bayValue !== bayValueToDelete));
  };

  const handleSubmit = () => {
    if (!groupName.trim()) {
      setError("Please enter a group name");
      return;
    }

    if (!selectedTime) {
      setError("Please select a time");
      return;
    }

    if (selectedBays.length === 0) {
      setError("Please select at least one bay");
      return;
    }

    setError("");

    const timeIn24HourFormat = dayjs(selectedTime).format("HH:mm");
    
    // Create FormData for payload - matches add dialog format
    const formData = new FormData();
    formData.append("group_name", groupName.trim());
    formData.append("time", timeIn24HourFormat);
    
    // Append each bay individually as bay[]
    selectedBays.forEach((bay) => {
      formData.append("bay[]", bay);
    });

    console.log("FormData entries:");
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    onConfirm(formData);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="edit-dialog-title">Edit Schedule</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          Edit the delivery truck schedule for group{" "}
          <strong>{schedule?.group_name}</strong>.
        </DialogContentText>

        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Group Name"
              value={groupName}
              onChange={(e) => {
                setGroupName(e.target.value);
                setError("");
              }}
              fullWidth
              size="small"
              required
              placeholder="Enter group name"
            />
          </Grid>

          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Select Time"
                value={selectedTime}
                onChange={(v) => {
                  setSelectedTime(v);
                  setError("");
                }}
                viewRenderers={{
                  hours: renderMultiSectionDigitalClockTimeView,
                  minutes: renderMultiSectionDigitalClockTimeView,
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    required: true,
                  },
                  layout: {
                    sx: {
                      "& .MuiDigitalClock-root": {
                        width: "100%",
                        maxHeight: "300px",
                      },
                    },
                  },
                }}
                ampm={true}
              />
            </LocalizationProvider>
          </Grid>

          {/* Bay Selection - Multiple Select with Chips - Same as Add Dialog */}
          <Grid item xs={12}>
            <FormControl fullWidth size="small" required>
              <InputLabel id="edit-bay-multiple-chip-label">Pulling Bay</InputLabel>
              <Select
                labelId="edit-bay-multiple-chip-label"
                id="edit-bay-multiple-chip"
                multiple
                value={selectedBays}
                onChange={handleBayChange}
                input={<OutlinedInput id="edit-select-multiple-chip" label="Pulling Bay" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip 
                        key={value} 
                        label={value} 
                        size="small"
                        onDelete={() => handleDeleteBay(value)}
                        onMouseDown={(e) => e.stopPropagation()}
                      />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
                disabled={loadingBays}
              >
                {loadingBays ? (
                  <MenuItem disabled>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CircularProgress size={20} /> Loading bays...
                    </Box>
                  </MenuItem>
                ) : bayOptions.length > 0 ? (
                  bayOptions.map((bay) => (
                    <MenuItem key={bay.id} value={bay.bay}>
                      {bay.bay}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No bays available</MenuItem>
                )}
              </Select>
              <FormHelperText>You can select multiple bays</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ mb: 2, mr: 2, mt: 2 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          color="primary"
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          color="primary"
          disabled={
            loading ||
            !groupName.trim() ||
            !selectedTime ||
            selectedBays.length === 0
          }
          sx={{
            backgroundColor: "#4CAF50",
            "&:hover": { backgroundColor: "#388E3C" },
            minWidth: "100px",
          }}
        >
          {loading && (
            <CircularProgress size={24} sx={{ mr: 1 }} color="inherit" />
          )}
          {loading ? "Updating..." : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditScheduleDialog;